import { create } from 'zustand'

export const useStore = create((set) => ({
  // Auth
  user: null,
  isAuthenticated: false,
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  logout: () => set({ user: null, isAuthenticated: false }),
  
  // Empresa seleccionada
  empresaActual: null,
  setEmpresaActual: (empresa) => set({ empresaActual: empresa }),
  
  // Notificaciones
  notifications: [],
  addNotification: (notification) => set((state) => ({
    notifications: [...state.notifications, { id: Date.now(), ...notification }]
  })),
  removeNotification: (id) => set((state) => ({
    notifications: state.notifications.filter(n => n.id !== id)
  })),
  
  // Loading
  isLoading: false,
  setIsLoading: (loading) => set({ isLoading: loading })
}))
